document.addEventListener('DOMContentLoaded', () => {

    const carouselBlocks = document.querySelectorAll('.carouselBlock .swiper')

    // Adding unique identifiers to each Swiper
    carouselBlocks.forEach((swiperElement, index) => {
        swiperElement.setAttribute('data-swiper-id', `article-swiper-${index}`)
    })

    // Function to initialize Swiper
    const initiateCarousel = swiperElement => {
        const identifier = `.swiper[data-swiper-id="${swiperElement.dataset.swiperId}"]` 

        const mainConfigs = {
            slidesPerView: "1",
            direction: 'horizontal',
            // spaceBetween: 1,
            loop: true,
            autoplay: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
              },
        }

        return [new Swiper(identifier, mainConfigs), new Swiper(identifier, progressConfigs)]
    }
    
    // Initializing swipers
    carouselBlocks.forEach(swiperElement => {
        const [mainSlider, progressSlider] = initiateCarousel(swiperElement)

        mainSlider.controller.control = progressSlider
    }) 
})